// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'De wijziging laden…',
  load_failed: 'Ik kon deze wijziging niet laden.',
  load_retry: 'Opnieuw proberen',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Dit was al goedgekeurd, dus er hoefde niets meer te gebeuren.',
  action_failed: 'Dat is niet gelukt, dus er is niets gewijzigd. Probeer het zo meteen opnieuw.',
  removed: 'Verwijderd',
  retry: 'Opnieuw proberen',
  retry_one: '{{name}} opnieuw proberen',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Goedgekeurd.',
    retried: 'Opnieuw geprobeerd.',
    rejected: 'Afgewezen.',
  },
  done: {
    summary_one: 'Klaar. {{count}} wijziging toegepast.',
    summary_other: 'Klaar. {{count}} wijzigingen toegepast.',
    skipped_one: '{{count}} overgeslagen, er is niets gewijzigd.',
    skipped_other: '{{count}} overgeslagen, er is niets gewijzigd.',
  },
  partial: {
    summary_one: '{{applied}} van {{approved}} wijzigingen toegepast. {{count}} niet.',
    summary_other: '{{applied}} van {{approved}} wijzigingen toegepast. {{count}} niet.',
    detail_one: 'De {{applied}} zijn opgeslagen. Voor de {{count}} hieronder is niets gewijzigd.',
    detail_other: 'De {{applied}} zijn opgeslagen. Voor de {{count}} hieronder is niets gewijzigd.',
  },
  stale: {
    summary: '{{applied}} van {{approved}} wijzigingen toegepast.',
    detail_one: '{{count}} is in de tussentijd door iemand anders gewijzigd.',
    detail_other: '{{count}} zijn in de tussentijd door iemand anders gewijzigd.',
    reason:
      '{{name}} heeft dit om {{time}} gewijzigd naar {{value}}, voordat je het goedkeurde, dus ik heb het laten staan. Hier is het opnieuw, vanaf de nieuwe waarde:',
  },
  undone: {
    summary_one: 'Ongedaan gemaakt. De {{count}} wijziging is weer zoals voorheen.',
    summary_other: 'Ongedaan gemaakt. De {{count}} wijzigingen zijn weer zoals voorheen.',
    detail: 'Het ongedaan maken is ook vastgelegd in het Amigo-logboek en onder Menu → Bewerkingsgeschiedenis.',
  },
  summary: {
    average: '{{amount}} per gerecht gemiddeld',
    needs_look: 'Controle nodig',
    nothing_else: 'Verder verandert er niets',
  },
  labels: {
    waiting: 'Wacht op goedkeuring',
    skip: 'Overslaan',
    unskip: 'Overslaan ongedaan maken',
    approve_all: 'Alles goedkeuren',
    approve_one: '{{count}} goedkeuren',
    approve_other: '{{count}} goedkeuren',
    approve_row: 'Goedkeuren',
    reject: 'Afwijzen…',
    reject_confirm: 'Afwijzen',
    back: 'Terug',
    why: {
      amigo: 'Waarom niet? (optioneel, Amigo leest dit)',
      assistant: 'Waarom niet? (optioneel, de assistent leest dit)',
    },
    hint: 'Of antwoord hieronder om iets te wijzigen.',
    show_all_one: 'Alle {{count}} wijzigingen tonen',
    show_all_other: 'Alle {{count}} wijzigingen tonen',
    show_less: 'Minder tonen',
    applying_one: '{{count}} wijziging toepassen…',
    applying_other: '{{count}} wijzigingen toepassen…',
    rows: {
      skipped: 'Overgeslagen',
      applied: 'Toegepast',
      failed: 'Niet toegepast',
      changed: 'Intussen gewijzigd',
      kept: 'Ongewijzigd gelaten',
    },
    history: {
      amigo: 'Openen in het Amigo-logboek',
      assistant: 'Openen in het logboek van de assistent',
    },
    undo: 'Ongedaan maken',
    to: 'naar',
    from: 'van',
    rejected: 'Afgewezen',
    replaced: 'Vervangen',
    expired: 'Verlopen',
  },
};
